module.exports = __webpack_public_path__ + "6757d13323ebb803847412fde831a1db.pdf";